import { render, staticRenderFns } from "./FileUploadField.vue?vue&type=template&id=16c4db88&scoped=true&"
import script from "./FileUploadField.vue?vue&type=script&lang=js&"
export * from "./FileUploadField.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadField.vue?vue&type=style&index=0&id=16c4db88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c4db88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
